module.exports = __webpack_public_path__ + "img/hr-garballo-09.537e4c3c.png";